import { sendToMixpanel } from '../mixpanel';

export default (): void => sendToMixpanel('View Tooltip');
